import { components } from "react-select";
import React from "react";

const Option = props => {
  const { isSelected, ...newProps } = props; // eslint-disable-line
  return <components.Option {...newProps} isActive />;
};

export default Option;



// WEBPACK FOOTER //
// ./src/components/Common/Form/FormDropdown/Option.js